import script from "./SlashCommandMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SlashCommandMenu.vue?vue&type=script&setup=true&lang=js"

import "./SlashCommandMenu.vue?vue&type=style&index=0&id=ccd7b0ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccd7b0ae"]])

export default __exports__